module.exports = __webpack_public_path__ + "img/el1.8b614a38.gif";